import { EditIcon, ExternalLinkIcon } from "@chakra-ui/icons";
import { Box, Flex, HStack, IconButton, Image, Text } from "@chakra-ui/react";
import debounce from "debounce";
import { useState } from "react";
import AsyncSelect from "react-select/async";
import http from "../../../core/http";

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: "#222b45",
    color: "white",
    cursor: "pointer",
    transition: "background-color 0.2s",
    "&:hover": {
      backgroundColor: "#4A5568",
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "gray.700",
    opacity: "1",
  }),
  control: (provided) => ({
    ...provided,
    backgroundColor: "gray.700",
    borderColor: "gray.600",
    color: "#fff !important",
    minWidth: "560px",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "white",
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
  }),
  optionLabel: (provided) => ({
    ...provided,
    display: "flex",
    alignItems: "center",
    color: "red",
  }),
  optionThumbnail: {
    width: "30px",
    height: "50px",
    marginRight: "10px",
  },
  input: (provided, state) => ({
    ...provided,
    // display: state.isSelected ? "inline-block" : "none",
    color: "#fff",
  }),
};

const ComicAutoComplete = ({ comic, handleAddOrReplace, index, franchise }) => {
  const [editMode, setEditMode] = useState(false);

  const fetchSuggestions = (query, callback) => {
    http
      .post(`/v1/search?franchise=${franchise}`, { search: query })
      .then((response) => {
        callback(response.data.data);
      });
  };

  const throttledLoadOptions = debounce(fetchSuggestions, 700);

  if (comic && comic.id && !editMode) {
    return (
      <Flex w="100%" justifyContent="space-between" alignItems="center">
        <Box color="white" display="flex" alignItems="center" p="2" flex="1">
          {comic.thumbnail && (
            <Image
              src={comic.thumbnail}
              alt={comic.title}
              style={customStyles.optionThumbnail}
            />
          )}
          <Box>{comic.title}</Box>
        </Box>
        <Box px="6" size="50px">
          <HStack>
            <a href={comic.url} target="_blank" rel="noopener noreferrer">
              <IconButton
                aria-label="Read"
                icon={<ExternalLinkIcon />}
                bg="gray.800"
                p="2"
                mx="2"
                color="white"
                _hover={{ bgColor: "gray.600" }}
              />
            </a>

            <IconButton
              aria-label="Edit comic"
              icon={<EditIcon />}
              onClick={() => {
                setEditMode(true);
              }}
              bg="gray.800"
              p="2"
              mx="2"
              color="white"
              _hover={{ bgColor: "gray.600" }}
            />
          </HStack>
        </Box>
      </Flex>
    );
  }

  return (
    <AsyncSelect
      key={`unique_select_key__${comic?.id}`}
      value={comic || ""}
      //   cacheOptions
      getOptionLabel={(option) => option.title}
      getOptionValue={(option) => option.id}
      //   onInputChange={handleInputChange}
      onChange={(option) => {
        handleAddOrReplace(index, option);
      }}
      //   inputValue={inputValue}
      //   defaultOptions
      loadOptions={throttledLoadOptions}
      placeholder="Search for a comic..."
      styles={customStyles}
      components={{
        Option: CustomOption,
        SingleValue: CustomSingleValue,
        NoOptionsMessage: CustomNoOptionsMessage,
        LoadingMessage: CustomNoOptionsMessage,
        Placeholder: CustomPlaceholder,
      }}
    />
  );
};

function CustomOption({ innerProps, data, isSelected }) {
  return (
    <div {...innerProps}>
      <Box
        bg={isSelected ? "blue.500" : "gray.700"}
        color="white"
        display="flex"
        alignItems="center"
        p="2"
        _hover={{ bg: "gray.600" }}
      >
        {data.thumbnail && (
          <Image
            src={data.thumbnail}
            alt={data.title}
            style={customStyles.optionThumbnail}
          />
        )}
        <Box>{data.title}</Box>
      </Box>
    </div>
  );
}

function CustomSingleValue(props) {
  return (
    <div {...props.innerProps}>
      <Box color="white" display="flex" alignItems="center" p="2">
        {props.data.thumbnail && (
          <Image
            src={props.data.thumbnail}
            alt={props.data.title}
            style={customStyles.optionThumbnail}
          />
        )}
        <Box>{props.data.title}</Box>
      </Box>
    </div>
  );
}

function CustomNoOptionsMessage(props) {
  return (
    <div {...props.innerProps}>
      <Box borderRadius="4" p="3" bg="gray.800">
        {props.children}
      </Box>
    </div>
  );
}

function CustomPlaceholder(props) {
  return (
    <div {...props.innerProps}>
      <Box top="5px" left="12px" position="absolute" bg="transparent">
        <Text color="gray.600">{props.children}</Text>
      </Box>
    </div>
  );
}

export default ComicAutoComplete;
